var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#62646E",
    fillRule: "evenodd",
    d: "M.355 2.169A1.276 1.276 0 0 1 .407.35a1.31 1.31 0 0 1 1.838.052L9 7.478 15.755.403A1.31 1.31 0 0 1 17.593.35c.522.488.545 1.301.052 1.818L11.123 9l6.522 6.832c.493.516.47 1.33-.052 1.817a1.31 1.31 0 0 1-1.838-.052L9 10.522l-6.755 7.075a1.31 1.31 0 0 1-1.838.052 1.276 1.276 0 0 1-.052-1.818L6.877 9 .355 2.169z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.27c5d06c7bed80ff47eba74a54007edf.svg";
export { ForwardRef as ReactComponent };